const getElementsPositions = ({ reactElements, domElements }) =>
  reactElements
    .map(({ key }) => {
      const element = domElements[key];

      if (!element) {
        return null;
      }

      const { left, bottom, top } = element.getBoundingClientRect();

      return {
        key,
        element,
        top,
        left,
        bottom
      };
    })
    .filter(position => position !== null);

export default getElementsPositions;
